import { CircularProgress, Grid } from "@mui/material";
import { Navigate, useSearchParams } from "react-router-dom";
import { useGetCandidateDetailsByEmailQuery } from "../../../redux/Hire/jobRequestApi";

type Props = {};

const CandidateRouterPage = (props: Props) => {
  const [params] = useSearchParams();
  const jobId = params.get("jobId");
  const candidateEmail = params.get("candidateEmail");

  const { data: candidateDetails, isFetching } =
    useGetCandidateDetailsByEmailQuery(
      {
        email: decodeURIComponent(candidateEmail || "") || "",
        jobId: jobId || "",
      },
      {
        skip: !candidateEmail || !jobId,
      },
    );

  if (isFetching) {
    return (
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        style={{ height: "100vh" }}
      >
        <CircularProgress />
      </Grid>
    );
  }
  return (
    <Navigate
      to={`/candidates/${candidateDetails?.data.id}?jobId=${jobId}`}
      replace
    />
  );
};

export default CandidateRouterPage;
